export const EXP_TYPES = {
  TOUR: 'tour',
  GROUP: 'group',
  PRIVATE: 'private',
  TICKET: 'ticket',
  TRANSFER_SERVICE: 'transfer_service',
  INDEPENDENT_WALK: 'independent_walk',
};
